import { getGovBudgetProjectList } from '../services';

export default {
  namespace: 'govBudgetProject',
  state: {},
  effects: {
    // 预算项目列表
    *getGovBudgetProjectList({ payload }, { call }) {
      return yield call(getGovBudgetProjectList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
